import type { DashboardCardDef } from '@edge/spark/io-dashboards'

/**
 * Converts workflows in widgetDef (DashboardCardDef) to workflows in RHF state (DashboardCardConfig)
 * Used for initial render
 */
export const convertDashboardCardDefToWorkflows = (widgetDef: DashboardCardDef): boolean[] | undefined => {
    if (!widgetDef.config?.workflows) {
        return undefined
    }

    const mappedWorkflows: boolean[] = []

    widgetDef.config.workflows.forEach((value) => {
        mappedWorkflows[value - 1] = true
    })

    return mappedWorkflows
}

export default convertDashboardCardDefToWorkflows
